module.exports = __webpack_public_path__ + "81f796e0ae545e334221cea3f68ec8e0.pdf";